const SERVICE_LABELS = {
  qbo_customer_deposits: 'QBO Customer Deposits',
  qbo_shipment_invoices: 'QBO Shipment Invoices',
  qbo_refunds: 'QBO Refunds',
  qbo_fee_journals: 'QBO Settlement / Merchant Fees',
  qbo_vendor_bills: 'QBO Vendor Bills',
  wayfair_returns: 'Returns',
  fulfilled_orders: 'Fulfilled Orders',
  cash_sales: 'Cash Sales',
  cash_refunds: 'Cash Refunds',
  price_levels: 'Price Levels'
};

export function formatServiceLabel(service, fallbackLabel = '') {
  if (!service) return '';
  const key = String(service);
  if (SERVICE_LABELS[key]) return SERVICE_LABELS[key];
  if (fallbackLabel) return fallbackLabel;

  return key
    .split('_')
    .filter(Boolean)
    .map(part => {
      const upper = part.toUpperCase();
      if (['QBO', 'POS', 'ERP', 'DTO'].includes(upper)) return upper;
      return part.charAt(0).toUpperCase() + part.slice(1);
    })
    .join(' ');
}
